import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

import { WorkshopContext } from "../contexts/workshop.context";

import { Button, ScenarioBox, ScreenBottom } from "../components/workshop";
import { defaultRoles, generateStarPickerStats } from "../util/workshop.util";
import { StatsChart } from "../components/insights";
import { getLocalStorage, getNextRoute, getPreviousRoute } from "../util/general.util";

const Task8c = ({ demoWorkshop }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentRoute = location.pathname.split("/task")[1];

  const [taskOrderUsers, setTaskOrderUsers] = useState([]);
  const [starSelections, setStarSelections] = useState([]);

  const {
    socket,
    user: { role } = {},
    workshopDetails: { platform } = {},
    workshopUsers
  } = useContext(WorkshopContext);

  const { t } = useTranslation();

  useEffect(() => {
    if (demoWorkshop) {
      setTaskOrderUsers(workshopUsers);

      try {
        const starPositions = getLocalStorage("task8");
        if (starPositions) {
          const starsList = t("resources.starsList", { returnObjects: true });
          const temp = generateStarPickerStats(starPositions, starsList);
          setStarSelections(temp);
        }
      } catch (error) {
        console.log(error);
      }

      return;
    }
    socket?.emit("taskOrder", 4, (users) => {
      if (users) setTaskOrderUsers(users);
    });
  }, []);

  useEffect(() => {
    if (demoWorkshop) return;

    socket?.emit("getTaskStatus", 8, (starPositions) => {
      if (!starPositions) return;

      const starsList = t("resources.starsList", { returnObjects: true });

      const temp = generateStarPickerStats(starPositions, starsList);
      setStarSelections(temp);
    });
  }, [platform]);

  const handleBack = () => {
    const previousRoute = getPreviousRoute(`/task${currentRoute}`, platform);
    if (demoWorkshop) {
      navigate(previousRoute);
    } else {
      socket?.emit("navigate", previousRoute);
    }
  };

  const handleNext = () => {
    const nextRoute = getNextRoute(`/task${currentRoute}`, platform);

    if (demoWorkshop) {
      navigate(nextRoute);
      return;
    }

    if (nextRoute === "end_workshop") {
      socket?.emit("endWorkshop");
      return;
    }

    socket?.emit("navigate", nextRoute);
  };

  return (
    <div className="flex flex-col gap-4">
      <h1
        dangerouslySetInnerHTML={{
          __html: t("mtActivityEight.headingC")
        }}
        className="text-5xl font-medium font-righteous text-gray-250"
      />

      {role === defaultRoles.participant && (
        <p
          dangerouslySetInnerHTML={{
            __html: t("mtActivityEight.subheadingC")
          }}
          className="text-xl text-gray-100"
        />
      )}
      {role === defaultRoles.moderator && (
        <p
          dangerouslySetInnerHTML={{
            __html: t("mtActivityEight.subheadingCMod")
          }}
          className="text-xl text-gray-100"
        />
      )}
      {role === defaultRoles.moderatorAndParticipant && (
        <p
          dangerouslySetInnerHTML={{
            __html: t("mtActivityEight.subheadingCModPart")
          }}
          className="text-xl text-gray-100"
        />
      )}

      {demoWorkshop && <ScenarioBox text={t("task2c.scenario")} />}

      {starSelections.length > 0 && (
        <div className="w-full bg-white-100 rounded-lg border-[1px] border-gray-100 p-4">
          <StatsChart data={starSelections} showSelectors={true} halfCol={true} />
        </div>
      )}

      <ScreenBottom helperText={t(`navigationHelperText.task8c`)}>
        {(role === defaultRoles.moderator || role === defaultRoles.moderatorAndParticipant) && (
          <>
            {!demoWorkshop && (
              <Button text={t("buttonBack")} onClick={handleBack} type={"outline"} />
            )}
            <Button text={t("buttonNext")} onClick={handleNext} />
          </>
        )}
      </ScreenBottom>
    </div>
  );
};

export default Task8c;
